export default __webpack_public_path__ + "static/media/linkedin.d28463eb.svg";